import React from "react";
import { motion } from "framer-motion";
import { pageMotion } from "../../framer/animation";
import SliderPage from "../../components/SliderPage/SliderPage";
import { Title } from "../../styles/reusables";
import { IoMdBriefcase } from "react-icons/io";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { projectsData } from "./Data/projectsData";
import { ProjectList } from "./styles";
import { Outlet } from "react-router-dom";

const Projects = () => {
	return (
		<>
			<SliderPage />
			<motion.div
				variants={pageMotion}
				initial='hidden'
				animate='show'
				exit='exit'
			>
				<Title>
					<IoMdBriefcase />
					<h2>Projects</h2>
				</Title>
				<ProjectList>
					{projectsData.map((project) => (
						<ProjectCard
							thumb={project.thumb}
							key={project.id}
							name={project.name}
							id={project.id}
						/>
					))}
				</ProjectList>
				<Outlet />
			</motion.div>
		</>
	);
};

export default Projects;
